<template>
  <div class="splashscreen">
    <div class="splashscreen-wrapper">
      <img
      class="splashscreen-logo"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAAAkCAMAAAA5MMHRAAAAolBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8ELnaCAAAANXRSTlMAoPD7wJALBlAD9z+zLxBgRDV8vbinW+B0VpZKIBSwbxnriejk0Mk5xa+a8oNljmopHdidJvKSiSIAAAPdSURBVFjD7ZaJkppAEIYbUC6RWwSFRaPG+8pm3v/VwtwzuGtVUpVKKvGvWhl6Fubrnu4e4KWXXnrptwtRwS9ogIhc+B0aohfgfw/ouMNgMEnHqi1JJ1lwmXt/BPB7aszKGriuKzYzEIjbr8w0LXqA9ojqjs3jcmgcWvbUjU4sOnNbEYsXp+/GrL39JKBzoVfDJlY7QELWGYhKS9oMRwOc0NFyoXjxdQudDHoT2XuE3vC+lGs+H4PUvcGLzsvSDT8B3CP+HCb0cqSqhU5fNNNEBXSZMQZoLdUxCRggArjA+FwXD7hMA5z0SJ46ND3Avg4AcEJSeMWS8VnCgloJ2Czp4ARQIFVzAfhGfqD5pi+lANqZZcSLuxug1fg5IBrD3Zd3yzFeIyV8fowvs8Tsfs1QAL7Ra+ZBc0Sqpg4DZJQQIF2FBAzWCR1W/mrxHPBdDaCZgDfhsZzjQM4ARj4J4UDLjtVCpMHkzEgqHXCOelo5HNA0RdUUyPgIcOamJh2tYUNy2KR8ACGb2OHXuThFMxwwBsjpcc5PKYjIz70OyDw9ns45TwIOiFq1v9aPgCXucizBF1bHF0JiIp/wicQOiMMspCsd8AsA1HR4res6pRHSAU3qCn7pOwsLB/QdEKpQ+wBI55lfo+4lNQZe4qjYhEMS8i23vEG/rEeoL1sAZtX4Rkc5SF9yDpiD1AK9PwBOQWlaMW7PuNuQvwxJ7UljYIAw6NUWuKivBQccAsB31kOVdXcccAaKrPwB0CLNZ0NvvvvYY0yn8+lbPBWAIhhb1FfNAJf4yZCON+S4YR5zwIMGGDzm4MQDiBisvUOc0GHlKIsk8lgf3/cA0Yjv2yXEGtXdj2eoUVuxfJd+nzhgpm3x4REQbYY5H0HL4iX5LEttMzEOcdEH3PEq9nGlF+Z0LLOmBKwD/0+Dn3eJKBJbLZLoaR9MIVxSQlvwuYUlG/X2SJqwAJQ9I2WjbzlG9SsBeAWxr7pPos2kIJT5zTPAYyNOLLIlBKwzWfpRFwMH3Hk5D324RpoiMPiAaKZP+2MBePQT2agv8ASQOnuhY8kH4FqqrVQ/FhJmrGDrI0WbpgfoZFpvr3BpDyb0qDPnjM//Zn8AKHxj9Z5KnPWWmuKlRL7q34NvbGc92CoxHDTQAwTnoJzyMd32KQG0c5RFyfY8QJv7hx+sZ7L8NAKmMds380vITc3wSD3f30AFlMl1BrDTKQtfAaAAco0Ci7p9CkEFBK9dE+zUAQ6oyxlFReKp1V6k6TV2QJE9L09l1cBz1fMomt/hM9mjKKpuIEUBAbykqjqCv1Id4N+tF+A/D/iZfgBIEGYNC66QfwAAAABJRU5ErkJggg==" />

      <span class="splashscreen-text">
        {{ $t('autoLogin.loadingText') }}
      </span>
    </div>
  </div>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';
import Vue from 'vue';
import SanitizeUtils from './../helpers/SanitizeUtils';

export default {
  name: 'splashscreen',
  mounted () {
    this.$http.post('/api-auto-login', {
      api_key: this.$route.params.token
    }).then(response => {
      if (response.data && response.data.error) {
        this.$router.push('/login/auto-login-wrong-data');
      } else if (response.data && response.data.token) {
        localStorage.setItem('bookero-auth-token', response.data.token);
        localStorage.setItem('bookero-last-visit-time', new Date().getTime());
        Vue.prototype.$http.defaults.headers['Authorization'] = 'Bearer ' + SanitizeUtils.getToken();

        setTimeout(() => {
          this.$router.push('/dashboard');

          setTimeout(() => {
            this.$bus.$emit('login-success');

            if (window.dataLayer) {
              window.dataLayer.push({ 'eventForm': 'login' });
            }
          }, 1000);
        }, 750);
      } else {
        this.$router.push('/login/auto-login-wrong-data');
      }
    }).catch(error => {
      this.$router.push('/login/auto-login-error');
      ErrorUtils.handleLoadError(error, '/api-auto-login', this.$router, this.$bus);
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.splashscreen {
  align-items: center;
  background: $color-primary;
  color: $color-light;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000000;

  &-wrapper {
    display: block;
  }

  &-logo {
    display: block;
  }

  &-text {
    display: block;
    font-size: 1.4rem;
    margin-top: 2rem;
    padding-left: 1rem;
    position: relative;
    text-align: center;
    width: 100%;

    &:before {
      animation-name: splashscreenSpinner;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      border: 4px solid $color-light;
      border-left-color: transparent;
      border-radius: 50%;
      content: "";
      display: block;
      height: 14px;
      left: -1rem;
      position: absolute;
      top: 1px;
      width: 14px;
    }
  }
}

@keyframes splashscreenSpinner {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/AutoLogin.vue